import React from 'react'
import { BackOfficeLayout } from 'components/Layout'

function withBackOfficeCms(PageComponent: React.FC) {
  return function EnhancedComponent<T>(props: T): JSX.Element {
    return (
      <BackOfficeLayout>
        <PageComponent {...props} />
      </BackOfficeLayout>
    )
  }
}

export default withBackOfficeCms
